import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Row, Select } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { FeatureTypeEnum } from "./api/Representation";
import { VehicleTypeCategoryEnum } from "../vehicleTypes/api/Representation";
const FeatureMultiSelect = ({ disabled = false, renderAsCheckboxGroup = true, onFeaturesLoaded, featureType = FeatureTypeEnum.VEHICLE, vehicleTypeCategory, value, onChange, }) => {
    const [availableFeatures, setAvailableFeatures] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    useEffect(() => {
        loadFeatureOptions();
    }, [featureType, vehicleTypeCategory]);
    useEffect(() => {
        onFeaturesLoaded && onFeaturesLoaded(availableFeatures);
    }, [availableFeatures]);
    const loadFeatureOptions = () => {
        const isVehicleType = featureType === FeatureTypeEnum.VEHICLE;
        if (isVehicleType && vehicleTypeCategory) {
            axios.get(`/admin/v1/features?type=${featureType}&vehicleCategory=${vehicleTypeCategory}&limit=1000`)
                .then(response => {
                let features = response.data.results;
                setAvailableFeatures(features);
                setSelectOptions(features.map(feature => {
                    return {
                        label: feature.description,
                        value: feature.id,
                    };
                }));
            })
                .catch(axiosErrorHandler);
        }
    };
    if (availableFeatures.length <= 0) {
        return null;
    }
    if (renderAsCheckboxGroup) {
        return (_jsx(Checkbox.Group, { disabled: disabled, onChange: onChange, value: Array.isArray(value) ? value : undefined, children: _jsx(Row, { children: availableFeatures.map(feature => {
                    return (_jsx(Col, { span: 24, children: _jsx(Checkbox, { value: feature.id, children: feature.description }) }, feature.id));
                }) }) }));
    }
    return (_jsx(Select, { mode: "multiple", style: { width: 300 }, disabled: disabled, onChange: onChange, value: value, options: selectOptions, placeholder: 'Features' }));
};
export default FeatureMultiSelect;
